import {local} from 'wix-storage';
 import wixWindow from 'wix-window';


 $w.onReady(function () {
   if(!local.getItem("firstTimePopupShown")) {
     wixWindow.openLightbox("Cookies");
     local.setItem("firstTimePopupShown", "yes");
   }
 } );